/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Petstore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface DriveVisit
 */
export interface DriveVisit {
    /**
     * 
     * @type {string}
     * @memberof DriveVisit
     */
    'transportId': string;
    /**
     * 
     * @type {string}
     * @memberof DriveVisit
     */
    'arrivalTime': string;
    /**
     * 
     * @type {string}
     * @memberof DriveVisit
     */
    'releaseTime': string;
    /**
     * 
     * @type {string}
     * @memberof DriveVisit
     */
    'cellId': string;
    /**
     * 
     * @type {TransportType}
     * @memberof DriveVisit
     */
    'transportType': TransportType;
}
/**
 * 
 * @export
 * @interface DriveVisitSummary
 */
export interface DriveVisitSummary {
    /**
     * 
     * @type {DriveVisit}
     * @memberof DriveVisitSummary
     */
    'drive_visit_info': DriveVisit;
    /**
     * 
     * @type {string}
     * @memberof DriveVisitSummary
     */
    'log_table': string;
}
/**
 * 
 * @export
 * @interface LogTable
 */
export interface LogTable {
    /**
     * 
     * @type {TableSchema}
     * @memberof LogTable
     */
    'schema': TableSchema;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof LogTable
     */
    'data': Array<{ [key: string]: string; }>;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface Pet
 */
export interface Pet {
    /**
     * 
     * @type {number}
     * @memberof Pet
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Pet
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Pet
     */
    'tag'?: string;
}
/**
 * 
 * @export
 * @interface TableSchema
 */
export interface TableSchema {
    /**
     * 
     * @type {Array<TableSchemaField>}
     * @memberof TableSchema
     */
    'fields': Array<TableSchemaField>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TableSchema
     */
    'primaryKey': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TableSchema
     */
    'pandasVersion': string;
}
/**
 * 
 * @export
 * @interface TableSchemaField
 */
export interface TableSchemaField {
    /**
     * 
     * @type {string}
     * @memberof TableSchemaField
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TableSchemaField
     */
    'type': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum TransportType {
    Dtp = 'DTP',
    Xdu = 'XDU'
}


/**
 * PetsApi - axios parameter creator
 * @export
 */
export const PetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a pet
         * @param {Pet} pet A *Pet* to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPets: async (pet: Pet, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pet' is not null or undefined
            assertParamExists('createPets', 'pet', pet)
            const localVarPath = `/pets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pet, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Pet by id
         * @param {number} petId The id of the pet to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePetById: async (petId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'petId' is not null or undefined
            assertParamExists('deletePetById', 'petId', petId)
            const localVarPath = `/pets/{petId}`
                .replace(`{${"petId"}}`, encodeURIComponent(String(petId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all pets
         * @param {number} [limit] How many items to return at one time (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPets: async (limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific pet
         * @param {number} petId The id of the pet to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showPetById: async (petId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'petId' is not null or undefined
            assertParamExists('showPetById', 'petId', petId)
            const localVarPath = `/pets/{petId}`
                .replace(`{${"petId"}}`, encodeURIComponent(String(petId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PetsApi - functional programming interface
 * @export
 */
export const PetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a pet
         * @param {Pet} pet A *Pet* to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPets(pet: Pet, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPets(pet, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Pet by id
         * @param {number} petId The id of the pet to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePetById(petId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePetById(petId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all pets
         * @param {number} [limit] How many items to return at one time (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPets(limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pet>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPets(limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a specific pet
         * @param {number} petId The id of the pet to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showPetById(petId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showPetById(petId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PetsApi - factory interface
 * @export
 */
export const PetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PetsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a pet
         * @param {Pet} pet A *Pet* to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPets(pet: Pet, options?: any): AxiosPromise<void> {
            return localVarFp.createPets(pet, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Pet by id
         * @param {number} petId The id of the pet to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePetById(petId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deletePetById(petId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all pets
         * @param {number} [limit] How many items to return at one time (max 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPets(limit?: number, options?: any): AxiosPromise<Array<Pet>> {
            return localVarFp.listPets(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific pet
         * @param {number} petId The id of the pet to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showPetById(petId: number, options?: any): AxiosPromise<Pet> {
            return localVarFp.showPetById(petId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PetsApi - object-oriented interface
 * @export
 * @class PetsApi
 * @extends {BaseAPI}
 */
export class PetsApi extends BaseAPI {
    /**
     * 
     * @summary Create a pet
     * @param {Pet} pet A *Pet* to be added
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public createPets(pet: Pet, options?: AxiosRequestConfig) {
        return PetsApiFp(this.configuration).createPets(pet, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Pet by id
     * @param {number} petId The id of the pet to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public deletePetById(petId: number, options?: AxiosRequestConfig) {
        return PetsApiFp(this.configuration).deletePetById(petId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all pets
     * @param {number} [limit] How many items to return at one time (max 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public listPets(limit?: number, options?: AxiosRequestConfig) {
        return PetsApiFp(this.configuration).listPets(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific pet
     * @param {number} petId The id of the pet to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PetsApi
     */
    public showPetById(petId: number, options?: AxiosRequestConfig) {
        return PetsApiFp(this.configuration).showPetById(petId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PodVisitsApi - axios parameter creator
 * @export
 */
export const PodVisitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all pod visits for the given tote id
         * @param {string} toteId Identifier of the tote to search for
         * @param {string} startTime Datetime of start of search
         * @param {string} endTime Datetime of end of search
         * @param {Array<string>} loggroups loggroups to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPodVistsForTote: async (toteId: string, startTime: string, endTime: string, loggroups: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toteId' is not null or undefined
            assertParamExists('getPodVistsForTote', 'toteId', toteId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getPodVistsForTote', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getPodVistsForTote', 'endTime', endTime)
            // verify required parameter 'loggroups' is not null or undefined
            assertParamExists('getPodVistsForTote', 'loggroups', loggroups)
            const localVarPath = `/podvisits/tote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (toteId !== undefined) {
                localVarQueryParameter['tote_id'] = toteId;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (loggroups) {
                localVarQueryParameter['loggroups'] = loggroups;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PodVisitsApi - functional programming interface
 * @export
 */
export const PodVisitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PodVisitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all pod visits for the given tote id
         * @param {string} toteId Identifier of the tote to search for
         * @param {string} startTime Datetime of start of search
         * @param {string} endTime Datetime of end of search
         * @param {Array<string>} loggroups loggroups to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPodVistsForTote(toteId: string, startTime: string, endTime: string, loggroups: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriveVisitSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPodVistsForTote(toteId, startTime, endTime, loggroups, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PodVisitsApi - factory interface
 * @export
 */
export const PodVisitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PodVisitsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all pod visits for the given tote id
         * @param {string} toteId Identifier of the tote to search for
         * @param {string} startTime Datetime of start of search
         * @param {string} endTime Datetime of end of search
         * @param {Array<string>} loggroups loggroups to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPodVistsForTote(toteId: string, startTime: string, endTime: string, loggroups: Array<string>, options?: any): AxiosPromise<Array<DriveVisitSummary>> {
            return localVarFp.getPodVistsForTote(toteId, startTime, endTime, loggroups, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PodVisitsApi - object-oriented interface
 * @export
 * @class PodVisitsApi
 * @extends {BaseAPI}
 */
export class PodVisitsApi extends BaseAPI {
    /**
     * 
     * @summary Get all pod visits for the given tote id
     * @param {string} toteId Identifier of the tote to search for
     * @param {string} startTime Datetime of start of search
     * @param {string} endTime Datetime of end of search
     * @param {Array<string>} loggroups loggroups to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodVisitsApi
     */
    public getPodVistsForTote(toteId: string, startTime: string, endTime: string, loggroups: Array<string>, options?: AxiosRequestConfig) {
        return PodVisitsApiFp(this.configuration).getPodVistsForTote(toteId, startTime, endTime, loggroups, options).then((request) => request(this.axios, this.basePath));
    }
}


